// Pure helpers for the floating map legend panels (components/MapLegends.tsx); no imports so
// tests/legendPanel.test.mjs can run it directly.

export const LEGEND_STORAGE_PREFIX = "amalgamesh:legendCollapsed:";

/** The localStorage key for one panel. Phone width has its own, so a choice made on a wide screen never decides how
 * the panel starts on a phone (where every panel starts folded). */
export function legendStorageKey(id: string, phone: boolean): string {
  return `${LEGEND_STORAGE_PREFIX}${id}${phone ? ":phone" : ""}`;
}

/** Whether the panel is folded: the remembered choice ("1" folded, "0" open), otherwise folded on a phone and open elsewhere. */
export function parseCollapsed(stored: string | null | undefined, phone: boolean): boolean {
  if (stored === "1") return true;
  if (stored === "0") return false;
  return phone;
}

export function serializeCollapsed(collapsed: boolean): string {
  return collapsed ? "1" : "0";
}
